import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddNewTemplateMode } from '@core/enums/add-new-template-mode.enum';
import { StiiraError } from '@core/models';
import { NewActionItemPost, NewActionItemsTemplatePost } from '@core/models/action-item-templates/action-item-templates-dashboard.model';
import { ErrorService, LayoutService } from '@core/services';
import { ActionItemsTemplatesService } from '@core/services/action-item-templates.service';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate, keepDialogOpen } from '@shared/helpers';
import { Observable, Subject } from 'rxjs';

@Component({
    selector: 'app-add-new-action-item-template',
    templateUrl: './add-new-action-item-template.component.html',
    styleUrls: ['./add-new-action-item-template.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddNewActionItmeTemplateComponent implements OnInit {
  static readonly componentName = 'AddNewActionItmeTemplateComponent';
  
  public form: UntypedFormGroup;
  public isSubmitting$: Subject<boolean>;
  public isMobile$: Observable<boolean>;
  public addNewTemplateMode = AddNewTemplateMode;
  public duplicateMessage: string;
  public position = position;
  public onDragEnded = onDragEnded;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { 
      sysText: any, 
      duplicateName: string,
      sourceId: number,
      mode: AddNewTemplateMode
    },
    private actionItemsTemplateService: ActionItemsTemplatesService,
    private errorService: ErrorService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddNewActionItmeTemplateComponent>,
    private layoutService: LayoutService
  ) {
    this.isSubmitting$ = new Subject();
    this.form = this.fb.group({
      name: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();
    if(this.data.duplicateName) {
      this.form.controls.name.patchValue(this.data.duplicateName + ' (' + this.data.sysText.copy + ')');
    }

    this.duplicateMessage = (this.data.mode == this.addNewTemplateMode.actionItem ? 
      this.data.sysText.duplicateActionItemMessage : 
      this.data.sysText.duplicateTemplateMessage)?.replace('@[sourceName]', this.data.duplicateName);
  }

  public onSubmit() {
    if (this.data.mode === AddNewTemplateMode.actionItemsTemplate) {
      const newTemplatePost: NewActionItemsTemplatePost = {
        templateName: this.form.controls.name.value,
        sourceId: this.data.sourceId
      }

      this.actionItemsTemplateService
        .postNewTemplate(newTemplatePost)
        .pipe(
          indicate(this.isSubmitting$),
          keepDialogOpen(this.dialogRef)
        )
        .subscribe((res) => {
          this.dialogRef.close(res);
        }, (err: StiiraError) => this.errorService.setFormModelStateErrors(this.form, err.modelStateErrors));
    } 
    
    else if (this.data.mode === AddNewTemplateMode.actionItem) {
      const newActionItemPost: NewActionItemPost = {
        actionItemName: this.form.controls.name.value,
        sourceId: this.data.sourceId
      }

      this.actionItemsTemplateService
        .postNewActionItem(newActionItemPost)
        .pipe(
          indicate(this.isSubmitting$),
          keepDialogOpen(this.dialogRef)
        )
        .subscribe((res) => {
          this.dialogRef.close(res);
        }, (err: StiiraError) => this.errorService.setFormModelStateErrors(this.form, err.modelStateErrors));
    }
  }
}
